module.exports = __webpack_public_path__ + "img/business12.df989148.png";